import { Badge } from "@/components/ui/badge";
import "./tech-tools.css";
import { cn } from "@/lib/utils";

export default function TechTools() {
  const languages = [
    { title: "TypeScript", slug: "typescript" },
    { title: "JavaScript", slug: "javascript" },
    { title: "Python", slug: "python" },
    { title: "C#", slug: "c-sharp" },
    { title: "PHP", slug: "php" },
    { title: "Java", slug: "java" },
    { title: "SQL", slug: "sql" },
  ];
  const tools = [
    { title: "Next.js", slug: "nextjs" },
    { title: "React", slug: "react" },
    { title: "Node.js", slug: "nodejs" },
    { title: "Unity", slug: "unity" },
    { title: "Tailwind CSS", slug: "tailwindcss" },
    { title: "Prisma", slug: "prisma" },
    { title: "GraphQL", slug: "graphql" },
  ];
  const dbs = [
    { title: "PostgreSQL", slug: "postgresql" },
    { title: "AWS S3", slug: "awss3" },
    { title: "Neon", slug: "neon" },
    { title: "FastAPI", slug: "fastapi" },
    { title: "Modal", slug: "modal" },
    { title: "Inngest", slug: "inngest" },
  ];
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
      {/* Programming Languages */}
      <div>
        <h4 className="font-semibold mb-4">Languages</h4>
        <div className="flex flex-wrap gap-2">
          {languages.map((lang) => (
            <Badge
              key={lang.slug}
              variant="secondary"
              className={cn(
                "border-foreground hover:border-primary bg-primary/10 hover:bg-primary/20 transition-colors rounded-lg",
                lang.slug && `t-badge ${lang.slug}`,
              )}
            >
              {lang.title}
            </Badge>
          ))}
        </div>
      </div>

      {/* Frameworks & Tools */}
      <div>
        <h4 className="font-semibold mb-4">Frameworks & Tools</h4>
        <div className="flex flex-wrap gap-2">
          {tools.map((tool) => (
            <Badge
              key={tool.slug}
              variant="secondary"
              className={cn(
                "border-foreground hover:border-primary bg-primary/10 hover:bg-primary/20 transition-colors rounded-lg",
                tool.slug && `t-badge ${tool.slug}`,
              )}
            >
              {tool.title}
            </Badge>
          ))}
        </div>
      </div>

      {/* Cloud & Database */}
      <div>
        <h4 className="font-semibold mb-4">Cloud & Database</h4>
        <div className="flex flex-wrap gap-2">
          {dbs.map((tech) => (
            <Badge
              key={tech.slug}
              variant="secondary"
              className={cn(
                "border-foreground hover:border-primary bg-primary/10 hover:bg-primary/20 transition-colors rounded-lg",
                tech.slug && `t-badge ${tech.slug}`,
              )}
            >
              {tech.title}
            </Badge>
          ))}
        </div>
      </div>
    </div>
  );
}
